import { ComboStepConfig } from '../shared/combo-types'

export const CLARIDAD_DIRECCION_NAME = 'Claridad y Dirección'

export const CLARIDAD_DIRECCION_PREAMBLE = {
    firstStepIntro:
        'Es la primera parte de un camino de claridad y dirección (encrucijada → mensaje de tus guías → temporada actual del alma).',
    finalStepClosing:
        'cerrá el arco del combo mostrando cómo la encrucijada, el mensaje de las guías y la temporada actual del alma se integran en un mismo camino de claridad, alineación y dirección consciente.',
}

export const CLARIDAD_DIRECCION_STEPS: ComboStepConfig[] = [
    {
        step: 1,
        type: 'combo-claridad-encrucijada',
        title: 'Tirada de Encrucijada del Alma',
        shortTitle: 'Encrucijada',
    },
    {
        step: 2,
        type: 'combo-claridad-guias',
        title: 'Tirada de Mensaje de tus Guías',
        shortTitle: 'Mensaje de tus Guías',
    },
    {
        step: 3,
        type: 'combo-claridad-temporada',
        title: 'Tirada de Temporada Actual del Alma',
        shortTitle: 'Temporada Actual del Alma',
    },
]

export const CLARIDAD_DIRECCION_TOTAL_STEPS = CLARIDAD_DIRECCION_STEPS.length
